export default __webpack_public_path__ + "static/media/WarningError.5943ac0e.svg";